import { resyJSONKeys, resyProductJSONKeys } from './jsonKeys';

import { PLATINUM_CODE, PLATINUM_CARD } from '../constants';

const DELTA_CARD_ID = '6';
const HILTON_CARD_ID = '7';

export const getUTMValues = (productDetails) => {
  const { cardCtaCampaignLink } = productDetails;
  return (cardCtaCampaignLink || '');
};

export const getCampaignId = (productDetails) => {
  let campaignId = '';
  let source = '';
  let medium = '';
  let campaign = '';

  const { cardCtaCampaignLink } = productDetails;
  if (cardCtaCampaignLink) {
    const campaignVariableArr = cardCtaCampaignLink.split('&');
    if (campaignVariableArr && campaignVariableArr.length === 3) {
      source = campaignVariableArr[0].split('=')[1] || '';
      medium = campaignVariableArr[1].split('=')[1] || '';
      campaign = campaignVariableArr[2].split('=')[1] || '';
      campaignId = `${source}-${medium}-${campaign}`;
      return campaignId;
    }
  }
  return null;
};

const validateJSONKeys = (jsonKeys, offersResyData, errorArray, cardName) => {
  if (!offersResyData) return;
  const cardNameValue = cardName || '';
  jsonKeys.forEach((key) => {
    if (Object.keys(offersResyData).indexOf(key) === -1) {
      errorArray.push(`[AmexGDAOffers] ${cardNameValue} gda_offers_resy_data Resy S3 field ${key} is not existing, Please fix and proceed`);
    } else {
      const val = offersResyData[key];
      if ((typeof offersResyData[key] === 'string' && val === '') || val === null) {
        errorArray.push(`[AmexGDAOffers] ${cardNameValue} gda_offers_resy_data Resy S3 Mandatory field ${key} value is empty or null, Please fix and proceed`);
      }
    }
  });
};

export const validateResyFields = (offersResyData, errorArray) => {
  validateJSONKeys(resyJSONKeys, offersResyData, errorArray);

  const {
    api_products: products,
    icon_mappings: iconMappings,
    additional_products: additionalProducts,
  } = offersResyData;

  if (iconMappings?.length === 0) {
    errorArray.push('[AmexGDAOffers] gda_offers_resy_data Resy S3 icon_mappings array is empty, Please fix and proceed');
  } if (products?.length === 0) {
    errorArray.push('[AmexGDAOffers] gda_offers_resy_data Resy S3 products array is empty, Please fix and proceed');
  } if (additionalProducts?.length === 0) {
    errorArray.push('[AmexGDAOffers] gda_offers_resy_data Resy S3 additional_products array is empty, Please fix and proceed');
  }
};

export const validateResyData = (offersResyData, productCode, cardName, errorArray) => {
  const { api_products: products } = offersResyData;
  const productDetails = products?.filter((product) => product.product_code === productCode)[0] ? products.filter((product) => product.product_code === productCode)[0] : null;
  cardName = `${cardName} Card`;
  if (!productDetails) errorArray.push(`[AmexGDAOffers] ${cardName} gda_offers_resy_data Resy S3 Mandatory field product_code value is empty or null, Please fix and proceed`);
  else validateJSONKeys(resyProductJSONKeys, productDetails, errorArray, cardName);
};

export const fetchOffersResyData = async (baseRequestUrl, errorArray) => {
  let offersResyData = null;

  const offersResyDataEndPoint = `${baseRequestUrl}GDA/Offers/gda_offers_resy_data.json`;

  try {
    const offersResyDataResponse = await fetch(offersResyDataEndPoint, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': baseRequestUrl,
      },
      mode: 'cors',
    });

    offersResyData = await offersResyDataResponse.json();
    validateResyFields(offersResyData, errorArray);
    validateResyData(offersResyData, PLATINUM_CODE, PLATINUM_CARD, errorArray);
    return offersResyData;
  } catch (error) {
    errorArray.push(`[AmexGDAOffers] RESY S3 Fetch Error: ${error}`);
  }
  return null;
};

export const validateUrlValue = (urls, cardName, urlName, errorArray) => {
  if (!urls.filter((url) => url.name === urlName)[0]) {
    const errMsg = `[AmexGDAOffers--${cardName}] Amex API ${urlName} is null or undefined, Please fix and proceed`;
    errorArray.push(errMsg);
  } else if (!urls.filter((url) => url.name === urlName)[0].value) {
    const errMsg = `[AmexGDAOffers--${cardName}] Amex API ${urlName} value field is null, Please fix and proceed`;
    errorArray.push(errMsg);
  }
  return errorArray;
};

export const validateAmexData = (offers, productCode, cardName, errorArray, products) => {
  const [productData] = offers?.filter((offer) => offer.product_code === productCode);
  const arrProductsResy = products?.filter((product) => product.product_code === productCode);
  const [productsResy] = arrProductsResy || [];
  const aprName = productsResy ? productsResy.apr_name : '';

  if (!productData) {
    const errMsg = `[AmexGDAOffers--${cardName}] Amex API offers for this card is not defined or product_code field is undefined, Please fix and proceed`;
    errorArray.push(errMsg);
  } else {
    const {
      urls, product_name: productName, fees, content_groups: contentGroups, rates,
    } = productData;
    if (!productName) {
      const errMsg = `[AmexGDAOffers--${cardName}] Amex API product_name is null or undefined, Please fix and proceed`;
      errorArray.push(errMsg);
    }
    if (!urls) {
      const errMsg = `[AmexGDAOffers--${cardName}] Amex API urls array is null or undefined, Please fix and proceed`;
      errorArray.push(errMsg);
    } else {
      errorArray = validateUrlValue(urls, cardName, 'APPLY_URL', errorArray);
      errorArray = validateUrlValue(urls, cardName, 'OFFER_TERMS_URL', errorArray);
      errorArray = validateUrlValue(urls, cardName, 'TERMS_AND_CONDITIONS_URL', errorArray);
      errorArray = validateUrlValue(urls, cardName, 'CARD_ART_URL', errorArray);
    }

    let contentGrpBenefits = [];
    let contentGrpMarketingOffer = [];
    if (!contentGroups) {
      const errMsg = `[AmexGDAOffers--${cardName}] Amex API content_groups array is null, Please fix and proceed`;
      errorArray.push(errMsg);
    } else {
      contentGrpBenefits = contentGroups.filter((content) => content.name === 'BENEFITS_TEXT');
      contentGrpMarketingOffer = contentGroups.filter((content) => content.name === 'MARKETING_OFFER_TEXT');
      const benefitArray = contentGrpBenefits[0] ? contentGrpBenefits[0].contents : [];
      if (!benefitArray) {
        const errMsg = `[AmexGDAOffers--${cardName}] Amex API Benefit's contents array is null or undefined, Please fix and proceed`;
        errorArray.push(errMsg);
      } else if (benefitArray && (benefitArray.length > 6 || benefitArray.length < 3 || benefitArray.length === 0)) {
        const errMsg = `[AmexGDAOffers--${cardName}] Amex API Benefit array size is more than 6 or less than 3 or equal to 0, Please fix and proceed`;
        errorArray.push(errMsg);
      } else if (benefitArray) {
        let isSequenceNumber = false;
        benefitArray.map((item) => {
          const {
            title, sequence_order: sequenceOrder, display_text: displayText,
          } = item;

          if (!title || !displayText) {
            const errMsg = `[AmexGDAOffers--${cardName}] Amex API Benefit array - title || display_text - null or undefined, Please fix and proceed`;
            errorArray.push(errMsg);
          } else if (!displayText[0]) {
            const errMsg = `[AmexGDAOffers--${cardName}] Amex API Benefit array - display_text[0]- null or undefined, Please fix and proceed`;
            errorArray.push(errMsg);
          } else if (!displayText[0].text) {
            const errMsg = `[AmexGDAOffers--${cardName}] Amex API Benefit array - display_text[0].text - null or undefined, Please fix and proceed`;
            errorArray.push(errMsg);
          } else if (!sequenceOrder) {
            isSequenceNumber = true;
            const errMsg = `[AmexGDAOffers--${cardName}] Amex API Benefit array - sequence_order - null or undefined, Please fix and proceed`;
            errorArray.push(errMsg);
          }
          return item;
        });

        if (!isSequenceNumber) {
          const valueArr = benefitArray.map((item) => item.sequence_order);
          const isDuplicate = valueArr.some((item, idx) => valueArr.indexOf(item) !== idx);
          if (isDuplicate) {
            const errMsg = `[AmexGDAOffers--${cardName}] Amex API Benefit array has duplicate sequence order, Please fix and proceed`;
            errorArray.push(errMsg);
          }
        }
      }

      const marketingArray = contentGrpMarketingOffer[0] ? contentGrpMarketingOffer[0].contents : [];
      if (!marketingArray) {
        const errMsg = `[AmexGDAOffers--${cardName}] Amex API Marketing's contents array is null or undefined, Please fix and proceed`;
        errorArray.push(errMsg);
      } else if (marketingArray && (marketingArray.length !== 1)) {
        const errMsg = `[AmexGDAOffers--${cardName}] Amex API Marketing array size is not equal to 1, Please fix and proceed`;
        errorArray.push(errMsg);
      } else {
        marketingArray.map((item) => {
          const {
            sequence_order: sequenceOrder, display_text: displayText,
          } = item;

          if (!sequenceOrder || !displayText) {
            const errMsg = `[AmexGDAOffers--${cardName}] Amex API Marketing array - sequence_order || display_text - null or undefined, Please fix and proceed`;
            errorArray.push(errMsg);
          } else if (!displayText[0]) {
            const errMsg = `[AmexGDAOffers--${cardName}] Amex API Marketing array - display_text[0] - null or undefined, Please fix and proceed`;
            errorArray.push(errMsg);
          } else if (!displayText[0] || !displayText[0].text) {
            const errMsg = `[AmexGDAOffers--${cardName}] Amex API Marketing array - display_text[0].text - null or undefined, Please fix and proceed`;
            errorArray.push(errMsg);
          }
          return item;
        });
      }
    }

    if (!rates) {
      const errMsg = `[AmexGDAOffers--${cardName}] Amex API rates array is null, Please fix and proceed`;
      errorArray.push(errMsg);
    } else if (aprName) {
      const aprRate = rates.filter((rate) => rate.name === aprName)[0];
      if (!aprRate) {
        const errMsg = `[AmexGDAOffers--${cardName}] Amex API ${aprName} value field is null, Please fix and proceed`;
        errorArray.push(errMsg);
      } else if (!aprRate.display_text) {
        const errMsg = `[AmexGDAOffers--${cardName}] Amex API ${aprName} display_text field is null or undefined or empty, Please fix and proceed`;
        errorArray.push(errMsg);
      }
    }

    if (!fees) {
      const errMsg = `[AmexGDAOffers--${cardName}] Amex API fees array is null, Please fix and proceed`;
      errorArray.push(errMsg);
    } else {
      const feesObj = fees.filter((fee) => fee.name === 'ANNUAL_FEE')[0];
      if (!feesObj) {
        const errMsg = `[AmexGDAOffers--${cardName}] Amex API ANNUAL_FEE field is null, Please fix and proceed`;
        errorArray.push(errMsg);
      } else if (!feesObj.value) {
        const errMsg = `[AmexGDAOffers--${cardName}] Amex API ANNUAL_FEE value field is null  or undefined or empty, Please fix and proceed`;
        errorArray.push(errMsg);
      }
    }
  }
};

export const validateDeltaHiltonData = (gdaAdditionalProducts, gdaAllCardProductOrder, errorArray) => {
  let deltaConfigured = '';
  let hiltonConfigured = '';
  let allCardOrderArray = [];
  let newGdaAllCardProductOrder = '';
  if (gdaAllCardProductOrder) {
    allCardOrderArray = gdaAllCardProductOrder.split(',');
    deltaConfigured = allCardOrderArray.find((element) => element === '6') || '';
    hiltonConfigured = allCardOrderArray.find((element) => element === '7') || '';
  }

  let deltaValuesPresent = false;
  let hiltonValuesPresent = false;

  if (gdaAdditionalProducts) {
    gdaAdditionalProducts.map((item) => {
      if (deltaConfigured && item.card_id === DELTA_CARD_ID) {
        if (item.card_name && item.card_image_file_name && item.card_title && item.card_cta_label && item.card_cta_link
          && item.card_cta_campaign_link && item.learn_more_track && item.card_offer_copy) {
          deltaValuesPresent = true;
        }
      }

      if (hiltonConfigured && item.card_id === HILTON_CARD_ID) {
        if (item.card_name && item.card_image_file_name && item.card_title && item.card_cta_label && item.card_cta_link
          && item.card_cta_campaign_link && item.learn_more_track && item.card_offer_copy) {
          hiltonValuesPresent = true;
        }
      }
      return null;
    });
  }

  if (deltaConfigured && !deltaValuesPresent) {
    errorArray.push('[AmexGDAOffers] GDA DELTA Additional Cards fields are missing, Please fix and proceed');

    const index = allCardOrderArray.indexOf(DELTA_CARD_ID);
    if (index > -1) { // only splice array when item is found
      allCardOrderArray.splice(index, 1); // 2nd parameter means remove one item only
    }
  }

  if (hiltonConfigured && !hiltonValuesPresent) {
    errorArray.push('[AmexGDAOffers] GDA HILTON Additional Cards fields are missing, Please fix and proceed');

    const index = allCardOrderArray.indexOf(HILTON_CARD_ID);
    if (index > -1) { // only splice array when item is found
      allCardOrderArray.splice(index, 1); // 2nd parameter means remove one item only
    }
  }

  newGdaAllCardProductOrder = allCardOrderArray.toString();
  return newGdaAllCardProductOrder;
};
